$(function () {
    // Close mobile menu
    $(document).on('click', '.drawer-overlay, .close-drawer-btn', function (event) {
        $('.mobile-menu').removeClass('menu--open');
        $('.drawer-overlay').removeClass('show');
        $('html').removeClass('sidebar--open');
        $('button.slideshow__pause').click();
    });

    // Open mobile menu
    $('#mobile-toggle').on('click', function () {
        $('button.slideshow__pause').click();
        if (!$('.mobile-menu').hasClass('menu--open')) {
            $('html').addClass('sidebar--open');
            $('.mobile-menu').addClass('menu--open');
            $('.drawer-overlay').addClass('show');
        } else {
            setTimeout(function () {
                $('.mobile-menu').removeClass('menu--open');
                $('.drawer-overlay').removeClass('show');
                $('html').removeClass('sidebar--open');
                $('button.slideshow__pause').click();
            }, 200);
        }
    });

    // Close Search Drawer
    $(document).on('click', '.drawer-overlay, .close-search-btn', function (event) {
        $('.search-sidebar').removeClass('search--open');

        setTimeout(function () {
            $('.drawer-overlay').removeClass('show');
            $('.search-btn').removeClass('active').focus();
            $('html').removeClass('sidebar--open');
            $('button.slideshow__pause').click();
        }, 500);
    });

    // Open Search Drawer
    $('.search-btn').on('click', function () {
        $('button.slideshow__pause').click();
        if (!$(this).hasClass('active')) {
            $('.search-sidebar').show();
            $('html').addClass('sidebar--open');
            $(this).addClass('active');
            $('.drawer-overlay').addClass('show');

            setTimeout(function () {
                $('.search-sidebar').addClass('search--open');
                $('input#searchInput').focus();
            }, 500);
        }
    });
});